<template>
    <div class='vue-calc'>
		<h2>Przelicznik miar i wag</h2>
        <Options @option='getValue' />
        <Output :choose="choose" :name="item"/>
    <img class="logo" src="../assets/logo.jpg" />
    </div>
</template>

<script>
import Options from '@/components/Options.vue';
import Output from '@/components/Output.vue';

export default {
  name: 'Calc',
  components: {
    Options,
    Output,
  },
  data() {
    return {
      choose: '',
      item: '',
    };
  },
  methods: {
    getValue(index, name) {
      this.choose = index;
      this.item = name;
    },
  },
};
</script>

<style scoped>
  .vue-calc{
    max-width: 455px;
    width: 100%;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3);
    background: #fff;
    border-radius: 25px;
    position: relative;
}

.vue-calc img{
  max-width: 120px;
  height: auto;
  position: absolute;
  bottom: 35px;
  right: 35px;
}

  .vue-calc h2{
    text-align: center;
    padding: 5px 0;
    font-size: 24px;
    line-height: 1.5;
    font-weight: 700;
    background: #f2f2f2;
    border-radius: 25px 25px 0 0;
  }
  
  @media (max-width: 455px){
    .vue-calc h2{
      border-radius: 0;
    }
    .vue-calc{
      box-shadow: none;
      border-radius: 0;
    }
  }

  @media (max-width: 400px){
    .vue-calc .logo{
      max-width: 75px
    }
  }

</style>
